/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

/** @format */

export const baseStyles = css`
    position: relative;
    display: block;
`;

/**
 * The form container component styles
 *
 * @param {SelectProps} props The select properties object
 */
export const styles = css`
    ${baseStyles}
`;
